import React, { useState } from "react";

// import JS files
import PanelTemplate from "../../../shares/PanelTemplate";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";
import TabThree from "./TabThree";
import TabFour from "./TabFour";

const CustomerCurrentOrders = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      <PanelTemplate sidebarActiveLink="c-current-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های جاری</span>
          </div>
          <div className="mt-8 flex items-center">
            <span
              className={activeTab == "1" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("1")}
            >
              براساس مشتری
            </span>
            <span
              className={activeTab == "2" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("2")}
            >
              براساس النگو
            </span>
            <span
              className={activeTab == "3" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("3")}
            >
              براساس مشتری (تجمیع شده)
            </span>
            <span
              className={activeTab == "4" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("4")}
            >
              براساس مشتری (کسری)
            </span>
          </div>
          <div
            style={{ backgroundColor: "#fefcfb" }}
            className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
          >
            {activeTab == "1" ? (
              <TabOne />
            ) : activeTab == "2" ? (
              <TabTwo />
            ) : activeTab == "3" ? (
              <TabThree />
            ) : (
              <TabFour />
            )}
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default CustomerCurrentOrders;
